import { CommonState, LoadCampaign, LoadLocations, LoadMyCampaigns } from './types';
import { RootState } from '@/store/types';
import { ActionContext, ActionTree } from 'vuex';
import {
  getOnlineClusteredAdSpaces,
  loadStoreOwnerLocationsAction,
} from '@/actions/adspaces/actions';
import { typeFromMime } from '@/utils/files';
import { LocationData } from '@/types/locations';
import { loadCampaignById, updateCampaign, } from '@/actions/campaigns/actions';
import { Campaign } from '@/types/campaigns';
import { OnlyRequired } from '@/types/misc';
import { loadMyCampaigns } from '@/actions/campaigns/advertiser';
import { AdSpace, AdSpacePriceControl } from '@/types/adspaces';
import { adSpaceTypesIcons } from '@/statics/ad-spaces';

export const actions: ActionTree<CommonState, RootState> = {
  loadLocations: async ({
                          commit,
                          dispatch,
                        }: ActionContext<CommonState, RootState>
  ): Promise<ReturnType<LoadLocations>> => {
    const adSpaces: AdSpace[] = await getOnlineClusteredAdSpaces();

    const locations = locationDataFactory(adSpaces);

      commit('setLocations', locations);
    await dispatch('CampaignWizardModule/syncSelectedLocations',
      locations, {
      root: true,
    });
    return locations;
  },
  loadCampaign: async (
    { commit, dispatch }: ActionContext<CommonState, RootState>,
    campaignId: string
  ): Promise<ReturnType<LoadCampaign>> => {
    return loadCampaignById(campaignId);
  },
  loadMyCampaigns: async ({
                            commit,
                          }: ActionContext<CommonState, RootState>
  ): Promise<ReturnType<LoadMyCampaigns>> => {
    const campaigns = await loadMyCampaigns();
    commit('setMyCampaigns', campaigns);
    return campaigns;
  },
  updateCampaign: async (
    { commit, dispatch }: ActionContext<CommonState, RootState>,
    campaignData: OnlyRequired<Campaign, 'ID'>
  ) => {
    return updateCampaign(campaignData);
  },
  loadStoreOwnerLocations: async ({ commit, rootGetters }: ActionContext<CommonState, RootState>) => {
    const userInfo = rootGetters['AuthModule/userInfo']

    const locations = await loadStoreOwnerLocationsAction()

    const storeOwnerLocations = locations.filter((location: LocationData) => location.SPACE_OWNER_ID === userInfo?.UID)

    commit('setLocations', storeOwnerLocations)

    return storeOwnerLocations;
  },
  loadRegulatorLocations: async ({ commit, dispatch, rootGetters }: ActionContext<CommonState, RootState>) => {
    const userInfo = rootGetters['AuthModule/userInfo']

    const locations = await dispatch('loadLocations')

    const regulatorLocations = locations.filter((location: LocationData) => location?.REGULATOR_ID === userInfo?.UID)

    commit('setLocations', regulatorLocations)

    return regulatorLocations;
  },
  clearAllData: async ({ commit }: ActionContext<CommonState, RootState>) => {
    commit('resetAllData');
  },
};

export function locationDataFactory(adSpaces: AdSpace[]): LocationData[]{
return adSpaces.map(
    (adSpace: AdSpace) => ({
      ...adSpace,
      clusterId: adSpace.SCREEN_CLUSTER_REF!.id,
      mediaList: (adSpace.MEDIA || []).map(({ PATH, TYPE, PATH_THUMBNAIL_200_PX }) => ({
        path: PATH,
        type: typeFromMime(TYPE),
        mime: TYPE,
        pathThumbnail200Px: PATH_THUMBNAIL_200_PX || PATH,
      })),
      media: {
        path: adSpace.MEDIA_FILE || adSpaceTypesIcons[adSpace.TYPE.VAL]?.icon,
        pathThumbnail200Px: adSpace.MEDIA_FILE_THUMBNAIL_200_PX || adSpace.MEDIA_FILE || adSpaceTypesIcons[adSpace.TYPE.VAL]?.icon,
        type: typeFromMime(adSpace.MEDIA_TYPE),
        mime: adSpace.MEDIA_TYPE,
      },
      selectable: Boolean(adSpace.BASE_PRICE || adSpace.FREQUENCY_PRICING),
      isPriceControlByShasha: adSpace.PRICE_CONTROL === AdSpacePriceControl.BY_SHASHA || !adSpace.PRICE_CONTROL,
    })
  );
}
